<template>
	 <v-container style="padding: 0;">
		<v-dialog title="待奖励积分列表" v-model="hideShow" width="1000" persistent>
			<v-card>
				<v-card-title>
					<span>课堂积分奖励</span>
					<v-spacer></v-spacer>
					<v-btn small color="error" @click="closeAllPoint" :disabled="data.total===0" >忽略全部积分</v-btn>
					<v-icon color="red" @click="cancel" class="ml-2">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-2">
					<v-data-table :headers="data.headers" :items="data.list" :loading="data.query.loading" class="elevation-1"
						disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
						
						
						
						<template v-slot:item.action="{item}">
							<v-btn small color="primary" @click="showGivePoint(item)">奖励</v-btn>
						</template>
					
					</v-data-table>
					<div class="pt-2">
						<v-row dense>
							<v-col cols="2" >
								<v-select :items="[10, 20, 50, 100]" @change="handleSizeChanged" dense hide-details label="每页数量"
									outlined v-model="data.query.size" />
							</v-col>
							<v-col cols="1" class="mt-2">
								<span>共{{data.total}}项</span>
							</v-col>
							<v-col cols="9" v-if="Math.ceil(data.total/data.query.size)>0">
								<v-pagination :length="Math.ceil(data.total/data.query.size)" @input="handlePageChanged"
									total-visible="5" v-model="data.query.page" />
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<giveStudentPoint :show="givePoint.show" :detailId="givePoint.detailId" :studentName="givePoint.studentName" @cancel="givePoint.show=false" @success="giveSuccess"></giveStudentPoint>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	import giveStudentPoint from "./give_student_point.vue"
	export default {
		name:"wait-give-point",
		components:{giveStudentPoint},
		props:{
			show:{
				type:Boolean,
				default:false
			}
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if (this.hideShow){
					this.getDataList();
				}
			}
		},
		data(){
			return {
				hideShow:this.show,
				shopId:"",
				data: {
					total:0,
					query:{
						loading:false,
						page:1,
						size:10
					},
					headers:[
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '学员',
							value: 'studentName',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				givePoint:{
					show:false,
					detailId:"",
					studentName:""
				}
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			console.log("wait-give-point-box mounted");
		
		},
		methods:{
			handleSizeChanged(size) {
				this.data.query.size = size;
				this.data.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.data.query.page = page;
				this.getDataList();
			},
			showGivePoint(item){
				this.givePoint.detailId = item.id;
				this.givePoint.studentName = item.studentName;
				this.givePoint.show = true;
			},
			giveSuccess(){
				this.getDataList();
				this.givePoint.show = false;
			},
			getDataList(){
				const that = this;
				let url = `/edu/teacher/wait/give/point/list/page/${that.data.query.page - 1}/size/${that.data.query.size}?v=1`;
				if(this.shopId){
					url += "&shopId="+this.shopId;
				}
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},
			closeAllPoint(){
				// 忽略全部
			
				const that = this;
				let url = `/edu/point/close/all?v=1`;
				if (this.shopId){
					url += "&shopId="+this.shopId;
				}else{
					this.$noty.error("操作失败");
					return
				}
							
				this.axios.post(url).then(response => {
					console.log(response)
					if (response.data["code"] === 200) {
						that.$noty.success("操作成功");
						that.$emit("updateCount","");//更新未读数
						that.cancel();
						return
					}else{
						that.$noty.error(response.data["message"])
					}
				})
			}
		}
	}
	
</script>

<style>
</style>
